import React from 'react';
import { useTranslation } from '../context/TranslationContext';

/**
 * Composant pour afficher les informations de la version actuelle
 */
export default function VersionInfo({ version, belTags }) {
  const { t } = useTranslation();

  if (!version) {
    return (
      <div className="bg-gray-50 p-4 rounded-md border border-gray-200">
        <div className="text-sm">
          <div className="font-medium text-gray-900">
            {t('CONFIG', 'CURRENT_VERSION', 'Current version')} : {t('CONFIG', 'UNDEFINED', 'undefined')}
          </div>
          <div className="text-gray-600 mt-1">
            {t('CONFIG', 'UNDEFINED', 'undefined')}
          </div>
          <div className="mt-2">
            <span className="font-medium">{t('CONFIG', 'TAGS', 'Tags')} : </span>
            <span className="text-gray-600">
              {belTags?.loading 
                ? t('CONFIG', 'LOADING', 'Loading...') 
                : t('CONFIG', 'UNDEFINED', 'undefined')
              }
            </span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-gray-50 p-4 rounded-md border border-gray-200">
      <div className="text-sm">
        <div className="font-medium text-gray-900">
          {t('CURRENT_VERSION', 'Current version')} : {version.title}
        </div>
        <div className="text-gray-600 mt-1">
          ID: {version.id}
        </div>
        <div className="mt-2">
          <span className="font-medium">{t('CONFIG', 'TAGS', 'Tags')} : </span>
          <span className="text-gray-600">
            {belTags?.loading 
              ? t('CONFIG', 'LOADING', 'Loading...') 
              : belTags?.error 
                ? `${t('CONFIG', 'ERROR', 'Error')}: ${belTags.error}`
                : belTags?.displayTags && Object.keys(belTags.displayTags).length > 0
                  ? Object.values(belTags.displayTags).map(tag => tag.display_label).join(', ')
                  : t('CONFIG', 'UNDEFINED', 'undefined')
            }
          </span>
        </div>
      </div>
    </div>
  );
}
